import { genComponentEl } from '@/utils/utils';
import Compo from './index.vue';

/**
 *
 * @param {{title: string,type: number,row: Object,container: HTMLElement,appendToBody: boolean}} data
 */
export function useDialog(data) {
  genComponentEl(Compo, data);
}
